import { ADMIN_PROFILE } from './index';
import { Action } from '../action';

export class AdminProfileInitAction implements Action {
	readonly type = ADMIN_PROFILE.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminProfileDestroyAction implements Action {
	readonly type = ADMIN_PROFILE.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminProfileClickSyncAction implements Action {
	readonly type = ADMIN_PROFILE.CLICK_SYNC;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminProfileClickNewContractAction implements Action {
	readonly type = ADMIN_PROFILE.CLICK_NEW_CONTRACT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminProfileClickNewAccessCodeAction implements Action {
	readonly type = ADMIN_PROFILE.CLICK_NEW_ACCESS_CODE;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminProfileClickNewAccountAction implements Action {
	readonly type = ADMIN_PROFILE.CLICK_NEW_ACCOUNT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}
